import { useState } from "react";
import { motion } from "framer-motion";

// styling
import styled from "styled-components";
//images
import arrowLink from "../images/arrowLink.svg";

import { worksConfig } from "../worksConfig";

function Projects({ textEnter, textLeave }) {
  const [isHovered, setIsHovered] = useState(false);
  const [hoveredProject, setHoveredProject] = useState(0);
  return (
    <SelectedWorkStyle>
      <div className="selected">selected works</div>

      {/* ------------------------   */}

      {worksConfig.map((work) => (
        <div
          key={work.id}
          id="work"
          onMouseEnter={() => {
            setIsHovered(true);
            setHoveredProject(work.id);
          }}
          onMouseLeave={() => {
            setIsHovered(false);
            setHoveredProject(0);
          }}
        >
          {/* column 1 --satrt */}
          <motion.div
            className="column-1"
            initial={{ x: "-96vw" }}
            whileInView={{ x: 0 }}
            transition={{
              type: "spring",
              stiffness: 500,
              mass: 4,
              damping: 50,
              delay: 0.2,
            }}
          >
            <div
              className="numbering"
              onMouseEnter={textEnter}
              onMouseLeave={textLeave}
            >
              0{work.id}
            </div>
            <motion.div
              className="project-name"
              onMouseEnter={textEnter}
              onMouseLeave={textLeave}
              whileHover={{
                letterSpacing: "0.4vw",
              }}
              transition={{
                type: "spring",
                stiffness: 500,
                mass: 8,
                damping: 20,
              }}
            >
              {work.title}
            </motion.div>
            <div className="live-site">
              <a
                className="link reduce"
                href={work.link}
                target="_blank"
                rel="noreferrer"
              >
                <div id="hit-him-up">live site</div>
                <img src={arrowLink} alt="live-site" />
              </a>
            </div>
          </motion.div>
          {/* column 1 --end */}
          {/* column 2 --satrt */}
          <motion.div
            className="column-2"
            initial={{ x: "96vw" }}
            whileInView={{ x: 0 }}
            transition={{
              type: "spring",
              stiffness: 500,
              mass: 4,
              damping: 50,
              delay: 0.4,
            }}
          >
            <div className="numbering"></div>
            <div className="project-description" id="work">
              {work.description}
              {/* Roles  */}
              <div>
                <div className="roles-title">ROLES</div>
                {work.roles.map((role, index) => (
                  <div key={index}>- {role}</div>
                ))}
              </div>
              {/* Roles ----- */}
            </div>
            <div>
              {work?.image && (
                <div className="project-image-container">
                  <img
                    className={
                      isHovered && hoveredProject === work.id
                        ? "project-image-hover"
                        : "project-image"
                    }
                    src={work?.image}
                    alt={work?.title}
                  />
                </div>
              )}
            </div>
          </motion.div>
        </div>
      ))}

      {/* -------------------------------  */}
    </SelectedWorkStyle>
  );
}

export default Projects;

export const SelectedWorkStyle = styled.div`
  text-transform: lowercase;

  .project-image {
    position: absolute;
    right: 1.5rem;
    width: 30%;
    -webkit-filter: blur(5px) grayscale(100%);
    filter: blur(10px) grayscale(100%);
    opacity: 0;
    right: 0;
    padding: 0;
    transition: all ease-out 0.4s;
    transition-delay: 0.2s;
  }

  .project-image-hover {
    position: absolute;
    right: 1.5rem;
    opacity: 70%;
    width: 30%;
    -webkit-filter: none;
    filter: none;
    padding-right: 18px;
    transition: all ease-out 0.4s;
    transition-delay: 0.2s;
  }

  .column-1,
  .column-2 {
    display: flex;
    align-items: flex-start;
    // margin-bottom: 80px;
  }
  .column-2 {
    margin-bottom: 80px;
  }

  .numbering,
  .project-name {
    font-family: "Monoton", cursive;
    font-size: 6vw;
  }

  .numbering {
    width: 20%;
  }
  .project-name {
    text-transform: uppercase;
    width: 70%;
  }

  .live-site {
    display: flex;
    justify-content: flex-end;
    width: 10%;
    margin-top: 20px;
  }
  .project-description {
    width: 40%;
    font-size: 1.8vw;
  }
  .roles-title {
    text-transform: none;
    margin-top: 2rem;
  }
  @media only screen and (max-width: 600px) {
    .numbering {
      width: 15%;
    }
    .project-name {
      text-transform: uppercase;
      width: 70%;
    }
    .live-site {
      display: flex;
      justify-content: flex-end;
      width: 15%;
      margin-top: 10px;
      font-size: 1.6rem;
    }
    .live-site > a > img {
      width: 1.5rem;
    }
    .project-description {
      font-size: 1.6rem;
      width: 70%;
    }
    .column-2 {
      margin-bottom: 40px;
    }
  }
`;
